import React from "react";

import { ProfileMenu } from "../ProfileMenu/ProfileMenu";

export function SelfSection(props) {
  return (
    <div className="d-flex align-items-center ml-auto">
      <ProfileMenu profile={props.config.profile} baseRoute={props.config.baseRoute} />
    </div>
  );
}
